export default __webpack_public_path__ + "static/media/Achievements_Image.d82b4c35.png";